export default {
  meta: {
    'key-content': 'Free Voice Call, Secure Communication, Instant Messaging, Burn After Reading, Secure Message',
    'description-content': 'Crait is a secure messaging and collaboration tool designed for enterprises to boost their productivity. Enterprise data is protected from surveillance or data breach because data is transported via a military-level encrypted channel.',
    'h-m-title': 'Crait | Your Secure Communication Platform'
  },
  head: {
    'home': 'Home',
    'features': 'Features',
    'pricing': 'Pricing',
    'resources': 'Resources',
    'openapi': 'Open API',
    'contact': 'Contact us',
    'download': 'Download',
    'login': 'Log-in',
    'console': 'Console',
    'CraitForWeb': 'Crait for web'
  },
  home: {
    'title1': 'Secure Communication',
    'title2': 'For Every One',
    'subtitle': 'Secure Chats · Read & Burn ·  Free Audio & Video Call',
    'placeholder': 'Email, phone or username',
    'getstart': 'Get Started',
    'contitle': 'Crait Advantage',
    'intro1-title': 'Support chats with up to 1000 people',
    'intro1-detail': 'Supports for creating 1000-person groups and multi-person conference call. All messages, pictures and videos are protected by end-to-end encryption.',
    'intro2-title': 'Secure Communication',
    'intro2-detail': 'Industry standard 256-bit AES end-to-end encryption is adopted across the platforms. To prevent any possible man-in-the-middle attack and to ensure data security, all communication goes through Transport Layer Security (TLS).',
    'intro3-title': 'Optimization of Organization Management',
    'intro3-detail': 'With administrative control, organizational structure can be built in the software, and employees can be authorized to different layers of data.',
    'intro4-title': 'Designed for Efficiency',
    'intro4-detail': 'Secure Mail and encrypted Cloud Drive ensures data is safe; Calendar sets up to-do items and improves work efficiency.',
    'keyfeature-title': 'Key Features',
    'keyfeature-list1': 'Secure Chats',
    'keyfeature-list2': 'Secure Audio Calls',
    'keyfeature-list3': 'Secure File Sharing',
    'keyfeature-list4': 'Synced Across All Platforms',
    'keyfeature-list5': 'Voice Messages',
    'keyfeature-list6': 'Secure Cloud Drive',
    'learnmore': 'Learn more',
    'download-title': 'Available for download on all popular platforms',
    'err-tip-email': 'Sorry,but the email is invalid',
    'err-tip-phone': 'Sorry,but the phone number is invalid',
    'click': 'Tap',
    'wx-tip1': 'icon in the top right corner',
    'select': 'Click',
    'wx-tip2': 'open in the browser'
  },
  features: {
    'f-title': 'Secure messaging tool designed to make working life easier.',
    'feature-title': 'Secure Communication',
    'feature-list1-title': 'Secure Chats',
    'feature-list1-detail': '1 to 1 chat and group chat up to 1000 users. Forward, recall and delete message options available.',
    'feature-list2-title': 'Secure Audio Calls',
    'feature-list2-detail': '1 to 1 audio call and group audio call up to 20 users. Mute function is available to silence the background noise.',
    'feature-list3-title': 'Conference Call',
    'feature-list3-detail': 'Enjoy end-to-end encrypted conference calls with auto-spotlight, for up to 20 users. The auto-spotlight feature amplifies the main speaker\'s voice, along with noise cancellation function.',
    'feature-list4-title': 'Synced Across All Platforms',
    'feature-list4-detail': 'Available for all major platforms.',
    'feature-list5-title': 'Voice Notes',
    'feature-list5-detail': 'Tap to record a voice message and release to finish recording and send.',
    'feature-list6-title': 'Secure File Sharing',
    'feature-list6-detail': 'Almost all file types supported including PDFs, DOC, XLS etc. Documents up to 100MB can be shared, and workgroups can collaborate together on the document.',
    'feature-list7-title': 'Secure Cloud Drive',
    'feature-list7-detail': 'Secure, cloud-based personal drive, providing you document access on-the-go without carrying any physical devices.',
    'feature-list8-title': 'Broadcast',
    'feature-list8-detail': 'Broadcasts are notices disseminated to pre-selected members of a workgroup. Broadcasts are delivered and received at once. This feature is useful for saving time and can be very useful for dealing with urgent matters.',
    'feature-list9-title': 'Security',
    'feature-list9-detail': 'Burn-and-read setting, read receipt setting, and screenshot protection functions are embedded in the platform.',
    'other-feature': 'Other Features',
    'other-list1-title': 'Customizable Plug-in Apps',
    'other-list1-detail': 'Plug-in Apps can be customized based on your industry needs or specific company needs. From team calendar sharing, meeting room reservation to office supply management, these Apps will be the communication tool to help you improve work efficiency and productivity.',
    'other-list2-title': 'Search',
    'other-list2-detail': 'Search through message threads to find old messages. Easily find contacts by searching with their email addresses or if you have special group chat privileges, assigned by an administrator, search through teams for contacts.'
  },
  pricing: {
    'p-title1': 'Features',
    'p-title2': 'Crait',
    'p-title3': 'Crait Pro',
    'unlimited': 'Unlimted',
    'tr1-td1': 'Max number of group allow to create',
    'tr2-td1': 'Max number of group members',
    'tr3-td1': 'Max number of Broadcast message recipients',
    'tr4-td1': 'Max number of conference members',
    'tr5-td1': 'Cloud space for group',
    'tr6-td1': 'Cloud space for personal',
    'tr7-td1': 'Video call',
    'tr8-td1': 'Plug-in List',
    'tr8-td2': 'Only server demos',
    'tr8-td3': 'Charged for each plug-in',
    'tr9-td1': 'Customer service and technical support',
    'tr9-td2': 'In App Support',
    'tr9-td3': '7x24h (mail or telephone)',
    'tr10-td1': 'Provides Team Manager website or app',
    'tr11-td1': 'Supports all platforms',
    'tr12-td1': 'Pricing',
    'tr12-td2': 'Free',
    'tr12-td3': '$2.99 per month',
    'btn1': 'Get Started',
    'btn2': 'Upgrade Now'
  },
  resources: {
    'readmore1': 'READ MORE ->',
    'readmore2': 'Read more',
    'r-title1': 'White paper',
    'r-title2': 'Blogs',
    'subtitle1': 'WHAT IS CRAIT?',
    'detail1': 'Crait is where secure communication and collaboration happens. It is a secure messaging tool designed to make working life easier and more productive for work-groups...',
    'subtitle2': 'Data Breach Trends',
    'detail2': 'Data breaches are no good. It will serve companies well to reexamine their basic security hygiene with a deliberate view of strengthening their respective security postures...',
    'subtitle3': 'Small Enterprises Are Easy Targets',
    'detail3': 'Not all commonsensical ideas hold water. One example of a commonplace idea that does not match reality is the notion that hackers only target big businesses. The rising number of cyber attacks on small businesses strongly contradicts this seemingly prevalent sentiment that small businesses aren’t the target of hacks. Let’s examine the facts...'
  },
  contact: {
    'c-title1': 'Thank you for your interest in Crait secure communication platform',
    'c-title2': 'please tell us more about your company and our sales team will be in touch shortly',
    'firstname': 'First Name *',
    'lastname': 'Last Name *',
    'workemail': 'Work Email *',
    'phone': 'Phone Number *',
    'company': 'Company Name *',
    'size': 'Company Size *',
    'location': 'Location',
    'industry': 'Industry',
    'send': 'Send',
    'emaillabel': 'Email: ',
    'email': 'info@craitapp.com'
  },
  download: {
    'intro': 'Crait is where workgroups communicate and collaborate securely. It is a secure messaging tool designed to make working life more efficient and productive. Available across various platforms, your messages and data can be synced among all your devices. ',
    'd-title': 'Available for download on all popular platforms',
    'sub-intro1': 'To install Crait,please scan the QR below or click the buttons below.',
    'sub-intro2': 'You can also log in to Crait to access the Web version',
    'home-download-title1': 'Boundless Collaboration',
    'home-download-title2': 'Free Message',
    'home-download-title3': 'Mail',
    'home-download-title4': 'Conference Call',
    'home-download-title5': 'Go to Crait for Web',
    'home-download-title6': 'Download Crait for PC',
    'home-download-title7': 'Try Crait Now',
    'home-download-title8': 'Cloud Drive',
    'download-getApp': 'Get the app for ',
    'download-iphone': 'iPhone',
    'download-scanCode': 'Scan Code',
    'download-dlApp': 'Download App',
    'download-gphone': 'Android',
    'download-pc': 'PC',
    'download-chrome': 'Chrome',
    'download-title-m': 'Boundless Collaboration',
    'download-dl-btn': 'Get Started'
  },
  payment: {
    'prices-payment-title1': 'Account to be upgraded',
    'prices-payment-title2': 'The account you want to upgrade to Crait Pro',
    'prices-payment-title3': 'The plan you want to purchase',
    'prices-payment-title4': 'Please select',
    'prices-payment-title5': 'Total',
    'prices-payment-title6': 'Payment',
    'prices-payment-title7': 'PayPal',
    'prices-payment-title8': 'Pay now',
    'prices-payment-title9': 'Upgrading to Crait Pro means you agree to the following terms',
    'prices-payment-title10': 'Crait Paid User Agreement',
    'prices-payment-title11': 'Privacy Policy',
    'prices-payment-title12': 'Network error!',
    'prices-payment-title13': 'Please enter a registered Crait account'
  },
  confirm: {
    'prices-confirm-title1': 'Account to be upgraded',
    'prices-confirm-title2': 'Choosed plan',
    'prices-confirm-title3': 'Total',
    'prices-confirm-title4': 'Payment',
    'prices-confirm-title5': 'Make the payment',
    'prices-confirm-title6': 'Going to third party payment page...',
    'prices-confirm-title7': 'Please make the payment in the third party page',
    'prices-confirm-title8': 'Failed to pay',
    'prices-confirm-title9': 'Payment made',
    'prices-confirm-title10': 'Network error!'
  },
  success: {
    'prices-success-title1': 'Your account has been upgraded to Crait Pro',
    'prices-success-title2': 'Your account will be upgraded to Crait Pro once we have confirmed the payment',
    'prices-success-title3': 'Upgraded account: ',
    'prices-success-title4': 'Plan purchased'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js